import {
    observable,
    action,
    toJS,
    runInAction
} from 'mobx';
import {ViewBase} from 'mutants-appfx';
import {Message} from 'tplus-components-touch';
import _clonedeep from 'lodash/cloneDeep'

class Memo extends ViewBase {
    get type(){
    return 'Memo';
    }

    @observable visible=false;
    @observable title;
    @observable head;
    @observable body;
    @observable cancelEnable
    output

    constructor(store,name){
        super(store,name);
    }

    @action init(initData){
        initData=_clonedeep(initData)
        this.title=initData.title;
        this.head=initData.data.head;
        this.body=initData.data.body;
        this.cancelEnable=initData.cancelEnable;
        this.show();
        return new Promise((resolve,reject)=>{
            this.output=resolve;
        })
    }

    @action show(){
        this.visible=true
    }

    @action hide(){
        this.visible=false
    }

    @action ok=()=>{
        this.hide();
        this.output(this.body)
    }

    @action cancel=()=>{
        this.hide();
        this.output();
    }

    @action changeValue(el, value) {
        el.Value = value
    }

    static fromJS(store) {
        return new Memo(store, 'Memo');
    }
}
export default Memo;
